/* eslint-disable no-unused-vars */
/* ICONS */
import { IoHeadsetOutline } from "react-icons/io5";
import { HiUsers } from "react-icons/hi2";
import { BsEmojiSmile } from "react-icons/bs";
import { MdContacts, MdContactSupport, MdContactPhone } from "react-icons/md";
import { IoIosBriefcase } from "react-icons/io";
import { HiDocumentText } from "react-icons/hi";
import { AiFillMessage } from "react-icons/ai";

const navMenu = [
  {
    id: 1,
    link: "/registration-form",
    icon: HiUsers,
    name: "Register your interest",
  },
  {
    id: 2,
    link: "/event",
    icon: BsEmojiSmile,
    name: "Events",
    secondary: "/event/add-event",
  },
  {
    id: 3,
    link: "/contact-us",
    icon: MdContacts,
    name: "Contact Us",
  },
  {
    id: 4,
    link: "/help-desk",
    icon: IoHeadsetOutline,
    name: "Help Desk",
  },
  {
    id: 5,
    link: "/libf-2026",
    icon: MdContactSupport,
    name: "Expo Queries",
  },
  {
    id: 6,
    link: "/expo-leads",
    icon: IoIosBriefcase,
    name: "Expo Pre-Booking",
  },
  /* {
    id: 7,
    link: "/push-notifications",
    icon: AiFillMessage,
    name: "Push Notifications",
  }, */
  {
    id: 8,
    link: "/startup-cell-contact-us",
    icon: MdContactPhone,
    name: "Contact us",
  },
  {
    id: 9,
    link: "/startup-applications",
    icon: HiDocumentText,
    name: "Applications",
  },
];

export default navMenu;
